import "../style.css";
import "./getalllivestreamscloud.css";
import {
  React,
  useState,
  Box,
  Modal,
  Empty,
  toast,
  useAddMediatoCloudMutation,
  Button,
  LoadingSpinner,
  VideoThumbnail,
  ReactPlayer,
  styled,
  Paper,
  Grid,
  captureeventbaseanalytics,
  Dialog,
  GetCookie,
  useUpdateMediaLiveMutation,
  Pagination,
  DeleteOutlineIcon,
  EditIcon,
} from "../../../Libraries/Media/index";
import ImageLazyLoading from "../../ImageLazyLoad/ImageLazyLoading";
import { truncateString } from "../../../Utils/stringtruncation";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { StyledMenu } from "../../../Utils/StyledMenu";
import { MenuItem } from "@mui/material";

const Item = styled(Paper)(({ theme }) => ({
  backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#fff",
  ...theme.typography.body2,
  textAlign: "center",
  color: theme.palette.text.secondary,
  boxShadow: "none",
}));

const GetAllLiveStreamsFromCloud = (props) => {
  const [pageNumber, setPageNumber] = useState(1);
  const itemsPerPage = 8;
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const [selectedVideo, setSelectedVideo] = useState();

  const [addMedia, { isLoading }] = useAddMediatoCloudMutation();
  const [updateLiveMedia, { isLoading: loading }] =
    useUpdateMediaLiveMutation();

  const [data, setdata] = useState({
    open: false,
    opendialogforvideo: false,
    opendialogforaddstream: false,
    opendialogforeditstream: false,
    livestreamlink: "",
    streamname: "",
    ser_media_id: "",
  });

  const opendialogforvideo = (link) => {
    setdata((previousvalue) => ({
      ...previousvalue,
      livestreamlink: link,
      open: true,
      opendialogforvideo: true,
      opendialogforaddstream: false,
      opendialogforeditstream: false,
    }));
  };

  const opendialogforaddstream = () => {
    setdata((previousvalue) => ({
      ...previousvalue,
      open: true,
      opendialogforvideo: false,
      opendialogforaddstream: true,
      opendialogforeditstream: false,
    }));
  };

  const opendialogforeditstream = (livevideo) => {
    setdata((previousvalue) => ({
      ...previousvalue,
      open: true,
      opendialogforvideo: false,
      opendialogforaddstream: false,
      opendialogforeditstream: true,
      livestreamlink: livevideo.txt_media_streaming_link,
      streamname: livevideo.txt_media_name,
      ser_media_id: livevideo.ser_media_id,
    }));
  };
  const closeVideo = () => {
    setdata((previousvalue) => ({
      ...previousvalue,
      open: false,
      opendialogforvideo: false,
      opendialogforaddstream: false,
      opendialogforeditstream: false,
      livestreamlink: "",
      streamname: "",
      ser_media_id: "",
    }));
  };

  const addNewLiveStream = async () => {
    if (
      data.streamname === "" ||
      data.streamname === null ||
      data.streamname === undefined ||
      data.streamname === "undefined" ||
      data.streamname === "null"
    ) {
      toast.error("Please add the stream name");
    } else if (
      data.livestreamlink === "" ||
      data.livestreamlink === null ||
      data.livestreamlink === undefined ||
      data.livestreamlink === "undefined" ||
      data.livestreamlink === "null"
    ) {
      toast.error("Please add the link");
    } else {
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("link", data?.livestreamlink);
      payload.append("link_name", data?.streamname);
      payload.append("upload_type", "Live");

      try {
        const response = await addMedia(payload).unwrap();
        if (
          response.connection === "true" &&
          response.status === "true" &&
          response.message === "Link saved successfully."
        ) {
          captureeventbaseanalytics(
            "Media",
            "boostboard-content/addMedia.php upload_type:Live RESPONSE",
            response.message
          );
          props.getAllMediaFunc();
          toast.success(response.message);
          setdata({
            ...data,
            open: false,
            opendialogforaddstream: false,
          });
        } else {
          toast.error(response.message);
          captureeventbaseanalytics(
            "Media",
            "boostboard-content/addMedia.php upload_type:Live RESPONSE",
            response.message
          );
        }
      } catch (error) {
        console.log(error);
        toast.error(error.message);
        captureeventbaseanalytics(
          "Media",
          "boostboard-content/addMedia.php upload_type:Live RESPONSE",
          error.message
        );
      }
    }
  };

  const handlePlayingError = () => {
    captureeventbaseanalytics("Media", "LIVE PLAYING ERROR", "ERROR");
    toast.error("Streaming error");
  };

  const EditLiveStream = async () => {
    captureeventbaseanalytics("Media", "Edit LIVE STREAM", "START");
    if (
      data.streamname === "" ||
      data.streamname === null ||
      data.streamname === undefined ||
      data.streamname === "undefined" ||
      data.streamname === "null"
    ) {
      toast.error("Please add the stream name");
      captureeventbaseanalytics(
        "Media",
        "Edit LIVE STREAM",
        "Please add the stream name for editing"
      );
    } else if (
      data.livestreamlink === "" ||
      data.livestreamlink === null ||
      data.livestreamlink === undefined ||
      data.livestreamlink === "undefined" ||
      data.livestreamlink === "null"
    ) {
      toast.error("Please add the link");
      captureeventbaseanalytics(
        "Media",
        "Edit LIVE STREAM",
        "Please add the stream link for editing"
      );
    } else {
      const payload = new FormData();
      payload.append(
        "txt_customer_id",
        localStorage.getItem("txt_customer_id")
      );
      payload.append("security_token", await GetCookie("es_token"));
      payload.append("ser_media_id", data?.ser_media_id);
      payload.append("txt_media_link", data?.livestreamlink);
      payload.append("txt_media_full_name", data?.streamname);

      try {
        const response = await updateLiveMedia(payload).unwrap();
        if (
          response.connection === "true" &&
          response.status === "true" &&
          response.message === "Live updated successfully"
        ) {
          captureeventbaseanalytics(
            "Media",
            "updateLive.php RESPONSE",
            response.message
          );
          props.getAllMediaFunc();
          toast.success(response.message);
          setdata({
            ...data,
            open: false,
            opendialogforaddstream: false,
            opendialogforeditstream: false,
            opendialogforvideo: false,
            streamname: "",
            ser_media_id: "",
            livestreamlink: "",
          });
        } else {
          toast.error(response.message);
          captureeventbaseanalytics(
            "Media",
            "updateLive.php RESPONSE",
            response.message
          );
        }
      } catch (error) {
        console.log(error);
        toast.error(error.message);
        captureeventbaseanalytics(
          "Media",
          "updateLive.php RESPONSE",
          error.message
        );
      }
    }
  };

  const addsidebarfooter = (
    <React.Fragment>
      <Button variant="contained" onClick={addNewLiveStream} className="capitalized fs-14 fw-bold">
        Add
      </Button>
    </React.Fragment>
  );

  const editlivevideofooter = (
    <React.Fragment>
      <Button variant="contained" onClick={EditLiveStream} className="capitalized fs-14 fw-bold">
        Save
      </Button>
    </React.Fragment>
  );

  const handlePageChange = (index) => {
    setPageNumber(index);
  };

  const handleClick = (event, media) => {
    setAnchorEl(event.currentTarget);
    setSelectedVideo(media);
  };

  const displayBulletins = props?.live
    .slice((pageNumber - 1) * itemsPerPage, pageNumber * itemsPerPage)
    .map((live, index) => {
      return (
        <Grid item xs={12} md={4} lg={3} key={index}>
          <Item
            style={{
              borderRadius: "0px",
            }}
          >
            <div
              onClick={() => opendialogforvideo(live.txt_media_streaming_link)}
            >
              <ImageLazyLoading
                src={VideoThumbnail}
                alt={"img"}
                width={"100%"}
                height={"200px"}
                style={{ borderRadius: "8px", border: "3px solid #F0F0F0" }}
              />
            </div>

            <Box
              display={"flex"}
              flexDirection={"row"}
              justifyContent={"space-between"}
              alignItems={"center"}
              mt={1}
            >
              <span>{truncateString(live.txt_media_full_name, 8)}</span>
              <Box
                flexGrow={1}
                display={"flex"}
                justifyContent={"flex-end"}
                alignItems={"center"}
                gap={1}
              >
                <div onClick={(e) => handleClick(e, live)}>
                  <MoreVertIcon />
                </div>
              </Box>
            </Box>
          </Item>
        </Grid>
        // <Grid item xs={12} md={4} lg={3} key={index}>
        //   <Item>
        //     <img
        //       src={VideoThumbnail}
        //       alt="img"
        //       width="100%"
        //       height="200"
        //       onClick={() => opendialogforvideo(live.txt_media_streaming_link)}
        //     />
        //     <div className="flex justify-content-between align-items-center">
        //       <span className="font-bold" style={{ color: "#1A75E8" }}>
        //         {live.txt_media_name}
        //       </span>

        //       <div className="p-2">
        //         <DeleteOutlineIcon
        //           className="deleteiconlive"
        //           onClick={() => props?.handleEnquireMedia(live)}
        //         />

        //         <EditIcon
        //           className="editiconlive"
        //           onClick={() => opendialogforeditstream(live)}
        //         />
        //       </div>
        //     </div>
        //   </Item>
        // </Grid>
      );
    });
  const pageCount = Math.ceil(props?.live?.length / itemsPerPage);

  return (
    <>
      {isLoading || loading ? <LoadingSpinner /> : null}
      <Box
        sx={{ flexGrow: 1, marginBottom: 2 }}
        display={"flex"}
        justifyContent={"end"}
      >
        <Button onClick={opendialogforaddstream} variant="contained" className="capitalized fs-14 fw-bold">
          ADD LIVE STREAM
        </Button>
      </Box>
      <Box className="live">
        {displayBulletins?.length > 0 ? (
          <>
            <Box sx={{ flexGrow: 1, marginBottom: 2 }} id="live">
              <Grid container spacing={2}>
                {displayBulletins}
                <StyledMenu
                  id="media-more-option"
                  MenuListProps={{
                    "aria-labelledby": "media-more-option",
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={() => setAnchorEl(null)}
                >
                  <MenuItem
                    disableRipple
                    onClick={() => {
                      props?.handleEnquireMedia(selectedVideo);
                      setAnchorEl(null);
                    }}
                  >
                    <DeleteOutlineIcon />
                    Delete
                  </MenuItem>
                  <MenuItem
                    disableRipple
                    onClick={() => {
                      opendialogforeditstream(selectedVideo);
                      setAnchorEl(null);
                    }}
                  >
                    <EditIcon />
                    Edit
                  </MenuItem>
                </StyledMenu>
              </Grid>
            </Box>
            <Pagination
              count={pageCount}
              color="primary"
              onChange={(event, value) => handlePageChange(value)}
              page={pageNumber}
            />
          </>
        ) : (
          <Empty />
        )}
      </Box>

      <Modal
        open={
          data?.open &&
          data?.opendialogforvideo &&
          !data?.opendialogforaddstream &&
          !data?.opendialogforeditstream
        }
        onClose={closeVideo}
        classNames={{
          overlayAnimationIn: "customEnterOverlayAnimation",
          overlayAnimationOut: "customLeaveOverlayAnimation",
          modalAnimationIn: "customEnterModalAnimation",
          modalAnimationOut: "customLeaveModalAnimation",
        }}
        animationDuration={800}
        styles={{
          modal: {
            width: "90%",
            padding: "unset",
            overflow: "hidden",
          },
          overlay: {
            background: "rgba(0, 0, 0, 0.5)",
          },
          closeButton: {
            background: "yellow",
          },
        }}
        center
      >
        {data.open === true &&
        data.opendialogforvideo === true &&
        data.opendialogforaddstream === false ? (
          <ReactPlayer
            url={data.livestreamlink}
            width="100%"
            controls={true}
            playing={true}
            onError={handlePlayingError}
          />
        ) : null}
      </Modal>

      <Dialog
        visible={
          data?.open &&
          (data?.opendialogforaddstream || data?.opendialogforeditstream) &&
          !data?.opendialogforvideo
        }
        style={{ width: "500px" }}
        breakpoints={{ "960px": "75vw", "640px": "100vw" }}
        header={
          data?.opendialogforaddstream
            ? "Add live stream"
            : data?.opendialogforeditstream
            ? "Edit live stream"
            : null
        }
        modal
        footer={
          data?.opendialogforaddstream
            ? addsidebarfooter
            : data?.opendialogforeditstream
            ? editlivevideofooter
            : null
        }
        onHide={closeVideo}
      >
        <div className="field">
          <input
            id="name"
            type="text"
            value={data?.streamname}
            onChange={(e) => setdata({ ...data, streamname: e.target.value })}
            placeholder="Live stream name"
            className="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          />
        </div>
        <div className="field">
          <input
            id="live"
            type="url"
            value={data?.livestreamlink}
            onChange={(e) =>
              setdata({ ...data, livestreamlink: e.target.value })
            }
            placeholder="Live stream link"
            className="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
          />
        </div>
      </Dialog>
    </>
  );
};

export default GetAllLiveStreamsFromCloud;
